import { Dispatch } from "redux";
import { AddChoicePayload, removeChoice } from "../../actions/choiceActions";
import { RootState } from "../../reducers";
import conditionsEffectRouter from "./conditionsRouter";

const addChoiceSideEffects = (
  { part }: AddChoicePayload,
  state: RootState,
  dispatch: Dispatch
) => {
  const { conditions, sections, pages } = state.formData.entities;
  const { sectionId: partSectionId, pageId: partPageId } = part;
  const partSection = sections.byId[partSectionId];
  const partPage = pages.byId[partPageId];
  if (!partSection || !partPage) return;

  if (partSection.type === "single") {
    state.choices.allIds.forEach((choiceId) => {
      const choice = state.choices.byId[choiceId];
      if (!choice) return;
      if (choice.sectionId === part.sectionId) {
        dispatch(removeChoice(choice.id));
      }
    });
  } else if (partSection.type === "group") {
    state.choices.allIds.forEach((choiceId) => {
      const choice = state.choices.byId[choiceId];
      if (!choice) return;
      const choiceSection = sections.byId[choice.sectionId];
      if (
        !choiceSection ||
        choice.pageId !== part.pageId ||
        choiceSection.type !== "group"
      )
        return;

      dispatch(removeChoice(choice.id));
    });
  }

  part.conditions.forEach((conditionId) => {
    const condition = conditions.byId[conditionId];
    if (!condition) return;

    conditionsEffectRouter("add")[condition.should](condition, state, dispatch);
  });
};

export default addChoiceSideEffects;
